/**
 * Display order for pump status filters and selects (matches business workflow order).
 * Varastossa → Käytössä → Poistettu altaasta → Palautuvien varasto → Matkalla korjaukseen
 * → Odottaa korjausta → Korjaus aloitettu → Korjattu → Poistettu.
 */
export const PUMP_STATUS_MENU_ORDER = [1, 2, 8, 9, 4, 3, 5, 6, 7];

/** Repairer (korjaaja) list/filter: see Käytössä (2) and Poistettu altaasta (8); hide Poistettu (7). */
export const PUMP_STATUS_MENU_ORDER_REPAIRER_FILTER = PUMP_STATUS_MENU_ORDER.filter(
  (code) => code !== 7
);

/**
 * Repairer settable statuses in the customer-requested order:
 * Palautuvien varasto → Matkalla korjaukseen → Odottaa korjausta → Korjaus aloitettu
 * → Korjattu → Varastossa (no 2/7/8).
 */
export const PUMP_STATUS_MENU_ORDER_REPAIRER = [9, 4, 3, 5, 6, 1];

/** Maintenance (huolto): backend hides repair pipeline pumps from listing — kept for filter parity. */
export const PUMP_STATUS_HIDDEN_MAINTENANCE = [3, 4, 5, 6];

export const PUMP_STATUS_MENU_ORDER_MAINTENANCE = PUMP_STATUS_MENU_ORDER.filter(
  (code) => !PUMP_STATUS_HIDDEN_MAINTENANCE.includes(code)
);

/** Mine / Maintenance settable cycle: warehouse ↔ in use ↔ removed from pool ↔ returning storage. */
export const PUMP_STATUS_HIDDEN_MINE_USER_DETAIL = [3, 4, 5, 6, 7];
export const PUMP_STATUS_MENU_ORDER_MINE_USER_DETAIL = PUMP_STATUS_MENU_ORDER.filter(
  (code) => !PUMP_STATUS_HIDDEN_MINE_USER_DETAIL.includes(code)
);

/** Maintenance settable statuses match backend (1, 2, 8, 9); Poistettu (7) is not assignable. */
export const PUMP_STATUS_MENU_ORDER_MAINTENANCE_SETTABLE =
  PUMP_STATUS_MENU_ORDER_MINE_USER_DETAIL;

/**
 * Returns the pump status codes a user with the given role is allowed to assign
 * via setting dropdowns (Edit, Add, Bulk, Detail). Order matches PUMP_STATUS_MENU_ORDER,
 * except for the repairer, who has its own workflow order.
 *
 * Role mapping:
 *   1 = Admin, 2 = YTM, 3 = Korjaaja, 4 = Kaivoskäyttäjä, 5 = Huolto/Urakoitsija
 */
export function getSettablePumpStatusCodes(role, currentStatus) {
  const n = Number(role);
  if (n === 3) return PUMP_STATUS_MENU_ORDER_REPAIRER;
  if (n === 4) return PUMP_STATUS_MENU_ORDER_MINE_USER_DETAIL;
  if (n === 5) {
    // Käytössä → Varastossa is blocked for maintenance (backend rejects it too).
    if (Number(currentStatus) === 2) {
      return PUMP_STATUS_MENU_ORDER_MAINTENANCE_SETTABLE.filter((code) => code !== 1);
    }
    return PUMP_STATUS_MENU_ORDER_MAINTENANCE_SETTABLE;
  }
  return PUMP_STATUS_MENU_ORDER;
}

const PUMP_STATUS_MENU_ORDER_INDEX = PUMP_STATUS_MENU_ORDER.reduce((acc, code, i) => {
  acc[code] = i;
  return acc;
}, {});

/**
 * Sort status codes for dropdowns. Unknown codes are appended in numeric order.
 */
export function sortPumpStatusCodesForMenu(codes) {
  return [...codes].sort((a, b) => {
    const ia = PUMP_STATUS_MENU_ORDER_INDEX[a];
    const ib = PUMP_STATUS_MENU_ORDER_INDEX[b];
    const hasA = ia !== undefined;
    const hasB = ib !== undefined;
    if (hasA && hasB) return ia - ib;
    if (hasA) return -1;
    if (hasB) return 1;
    return a - b;
  });
}

/**
 * Pump status is stored as integer codes on the API. CSS badge colors map by code (not by label language).
 */
export const PUMP_STATUS_COLOR_CLASS = {
  1: "status-orange",
  2: "status-green",
  3: "status-yellow",
  4: "status-yellow",
  5: "status-yellow",
  6: "status-green",
  7: "status-red",
  8: "status-orange",
  9: "status-yellow",
};

export function pumpStatusTranslationKey(code) {
  const n = Number(code);
  if (!Number.isFinite(n) || n < 1 || n > 9) return "pump_status_unknown";
  return `pump_status_${n}`;
}
